import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const PreferencesModel = types.model({
  moment_interval: types.string,
  moment_score: types.maybeNull(types.string),
});

export interface PreferencesInstance extends Instance<typeof PreferencesModel> {}
export type PreferencesSnapshot = SnapshotIn<typeof PreferencesModel>;
